import { Component, Prop, h, Event, EventEmitter, State } from '@stencil/core';

@Component({
  tag: 'qumra-option-input',
  styleUrl: 'qumra-option-input.css', // يمكنك إضافة ملف CSS إذا كان لديك تصميم خاص
  shadow: false,
  formAssociated: true
})
export class QumraOptionInput {

  @Event() optionChange: EventEmitter<any>;

  @Prop() data: string; 
  @Prop() selected: string; 

  @State() properties: any;
  @State() selectedValue: string;

  componentWillLoad() {
    this.properties = JSON.parse(this.data);
    this.selectedValue = this.selected;
  }

  handleOptionClick(value: string) {
    this.selectedValue = value; 
    this.optionChange.emit({ property: this.properties.id, value: this.selectedValue }); 
  }

  render() {
    return (
      <div class="qumra-option-input-container">
        {this.properties.values.map((property: { id: string; title: string }) => (
        
        <div
          style={{ 
            backgroundColor: this.selectedValue === property.id ? '#d1d5db ' : ''
          }}
            onClick={() => this.handleOptionClick(property.id)}
          >
             <input
              type="radio"
              id={`color-${property.id}`}
              name={`property[${this.properties.id}]`}
              value={property.id}
              style={{ display: 'none' }}
              onChange={() => this.handleOptionClick(property.id)}
              checked={this.selectedValue === property.id}
            />
            {property.title ? property.title : "لا يوجد قيمة"}
          </div>
        ))}
      </div>
    );
  }
}
